import React from "react"
import { Col, Container, Row } from "react-bootstrap"

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import * as styles from "./FeaturedEventsPanel.module.scss"

function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  function getFullMonth(month){
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[month];
  }
  
  const formateDate = (dateString) => {
    return[
      padTo2Digits(dateString.getDate()),
      getFullMonth(dateString.getMonth()),
      padTo2Digits(dateString.getFullYear()),
    ].join(' ')
  }

const FeaturedEventsPanel = ({blok, cardData}) => {

    // let allFeatEvents = blok.events;
    let vaildEvents = cardData.filter(event => {
    // let vaildEvents = allFeatEvents.filter(event => {
        return Date.parse(new Date(event.expires)) > Date.now()
    });

    //TEMP
    let featured = null;
    let link = null;
    let formDate = null;
    if( vaildEvents.length > 0){
        featured = vaildEvents[0];
        // let featured = allFeatEvents[0].event.content;
        link = vaildEvents[0].link;
        // let link = allFeatEvents[0].event.full_slug;
         formDate = formateDate(new Date(featured.date.replace(/-/g, "/")));
    }

    if( featured ){
        return ( 
            <PanelWrapper blok={blok}>
            <div className="shadow-cards">
              <Container className="panel-radius">
                <Row>
                  <Col xs={12} lg={7} style={{padding:0}} className={styles.featImage}>
                    {featured && featured.thumbnail && (featured.thumbnail.filename !=="" && featured.thumbnail.filename !== null) ? <StoryblokImage sbImageData={featured.thumbnail} /> : featured.image && featured.image.filename !== "" ? <StoryblokImage sbImageData={featured.image} />: <h1>Test</h1>}
                  </Col>
                  <Col xs={12} lg={5} className={styles.rightCol}>
                    <div className={styles.content}>
                        <div className={styles.label}>
                            {(featured.date && featured.endDate) && (featured.date !== featured.endDate) ? <span>{formateDate(new Date(featured.date))} - {formateDate(new Date(featured.endDate))}</span> : featured.date ? <span>{formateDate(new Date(featured.date))}</span> : null} 
                            {featured.date && featured.location ? " | " : null}
                            {featured.location ? <span>{featured.location}</span>: null}
                        </div>
                     
                     {/* <span>{featured.date ? `${featured.date} |` : null} {featured.location ? `${featured.location}`: null} </span>  */}
                      {featured.headline ? <h3>{featured.headline}</h3> : null}
                      {featured.excerpt ? <p>{featured.excerpt}</p> : null}
                      <a href={link} className="btn start-green">Learn More</a>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </PanelWrapper>
         );
    }
    return null;
    
}
 
export default FeaturedEventsPanel;